export default "__VITE_ASSET__NsO55l2q__"